import Sidebar from './Sidebar';
import Navbar from './Navbar';
import React from 'react';
import './style.css';

import axios from "axios"
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useRef } from "react";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const NewSale = () => {

    let history = useNavigate();

    // select client name
    const [clients, setClients] = useState([]);
    const [selectedClient, setSelectedClient] = useState('');

    const [data, setData] = useState({
        clientName: "",
        address: "",
        netWeight: ""
    })

    useEffect(() => {
        fetch('https://react-apis.dotlocalhost.com/dropcustomer.php')
            .then(response => response.json())
            .then(data => setClients(data))
            .catch(error => console.error('Error fetching client names:', error));

        fetch('https://react-apis.dotlocalhost.com/newsales.php')
            .then(response => response.json())
            .then(data => setUsers(data))
            .catch(error => console.error('Error fetching users:', error));
    }, []);

    const handleClientChange = (event) => {
        setSelectedClient(event.target.value);
    };

    // select client name

    // select Purchase Id and other options

    const handleChange = (e) => {
        setData({ ...data, [e.target.name]: e.target.value });

        //console.log(data)
    }

    const [users, setUsers] = useState([]);
    const [selectedPurchaseid, setSelectedPurchaseid] = useState('');
    const [shippingmark, setShippingmark] = useState(null);
    const [productName, setProductName] = useState(null);
    const [packing, setPacking] = useState(null);
    const [totalWeight, setTotalWeight] = useState(null);
    const [quantity, setQuantity] = useState(null);

    const handleUserChange = (event) => {
        const ProName = event.target.value;
        setSelectedPurchaseid(ProName);

        setQuantityPri(0);
        setSalesQuantityPri(0);

        if (ProName) {
            fetch(`https://react-apis.dotlocalhost.com/newsales.php?purchage_Id=${ProName}`)
                .then(response => response.json())
                .then(data => setShippingmark(data.shipping_mark) | setProductName(data.productName) | setPacking(data.packing) |
                    setTotalWeight(data.totalWeight) | setQuantity(data.quantity))
                //.then(data => setUserNetWeight(data.netWeight))
                .catch(error => console.error('Error fetching packing:', error));
        } else {
            setShippingmark(null);
            setProductName(null);
            setPacking(null);
            setTotalWeight(null);
            setQuantity(null);
        }

    // View Remaining Quantity
        if (ProName) {
            fetch(`https://react-apis.dotlocalhost.com/stockShow.php?purchage_Id=${ProName}`)
                .then(response => response.json())
                .then(data => setProductName(data.productName) | setQuantityPri(data.quantity) | setSalesQuantityPri(data.salesQuantity))
                //.then(data => setUserNetWeight(data.netWeight))
                .catch(error => console.error('Error fetching packing:', error));
        } else {
            setProductName(null);
            setQuantityPri(null);
            setSalesQuantityPri(null);
        }

        
    // View Remaining Quantity

    };

    // select Purchase Id and other options

    // View Remaining Quantity

    const [salesQuantityPri, setSalesQuantityPri] = useState(null);
    const [quantityPri, setQuantityPri] = useState(null);

    const [totalStock, setTotalStock] = useState(0);

    useEffect(() => {
        const calculateTotalQuantity = () => {
        const total = quantityPri - salesQuantityPri;
        setTotalStock(total);
        };
        calculateTotalQuantity();
    }, [quantityPri, salesQuantityPri]);

    // View Remaining Quantity

    // Calculate weight and price

    const [shortage, setShortage] = useState(0);
    const [salesQuantity, setSalesQuantity] = useState(0);
    const [dataMaan, setDataMaan] = useState(null);
    const [salesPrice, setSalesPrice] = useState(0);
    const [bagWeight, setBagWeight] = useState(null);
    const [saleTotalWeight, setSaleTotalWeight] = useState(null);
    const [saleTotalPrice, setSaleTotalPrice] = useState(null);

    useEffect(() => {
        const calculateTotalWeight = () => {
            const bagtotal = (totalWeight / quantity);
            setBagWeight(bagtotal);
            const total = (bagWeight * salesQuantity) - shortage;
            setSaleTotalWeight(total);

            const total2 = dataMaan / 40 ;
            setSalesPrice(total2);

            const total3 = (saleTotalWeight * salesPrice);
            setSaleTotalPrice(total3);
        };

        if (salesQuantity > totalStock) {
            alert('Sales quantity cannot be larger than total stock!');
            setSalesQuantity('');
        }

        calculateTotalWeight();
    }, [totalWeight, shortage, salesQuantity, saleTotalWeight, dataMaan, salesPrice, saleTotalPrice]);

    

    // Calculate weight and price

    // Upload Data to mysql database

    const [selectedDate, setSelectedDate] = useState(null);

    const handleDateChange = (date) => {
        setSelectedDate(date);
    };

    const submitForm = (e) => {
        e.preventDefault();

        if (salesQuantity === '') {
        alert('Sales quantity cannot be null or empty!');
        } else {
        
            const sendData = {
                customerName: selectedClient,
                purchage_Id: selectedPurchaseid,
                shipping_mark: shippingmark,
                productName: productName,
                packing: packing,
                bagWeight: bagWeight,
                salesQuantity: salesQuantity,
                shortage: shortage,
                saleTotalWeight: saleTotalWeight,
                salesPrice: salesPrice,
                totalBill: saleTotalPrice,
                duedate: selectedDate
            }

            console.log(sendData);

            axios.post('https://react-apis.dotlocalhost.com/newAddSale.php', sendData).then((result) => {
                if (result.data.Status == 'Invalid') {
                    alert('Invalid purchase');
                } else {
                    history('/sales');
                }
            })

        }

    }

    // Upload Data to mysql database

    // Generating PDF

    const inputRef = useRef(null);
    const printDocument = () => {
        html2canvas(inputRef.current).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF();
        pdf.addImage(imgData, "JPEG", 0, 0);
        pdf.save("download.pdf");
        });
    };

    // Generating PDF

    return (
        <div class="wrapper">
            <Sidebar />
            <div id="content">
                <Navbar />

                <div className='ineerBody'>

                    <div className='row'>
                        <div className='col-md-12 mb-5'>
                            <h3>This is Add Sales Page</h3>
                        </div>
                    </div>

                    <input type="text" name="totalWeight" className='form-control hideInput' onChange={handleChange} value={totalWeight} />
                    <input type="text" name="totalWeight" className='form-control hideInput' onChange={handleChange} value={quantity} />

                    <form onSubmit={submitForm}>

                        <div id="divToPrint" ref={inputRef}>

                            <div className='row' style={{marginBottom:'4%'}}>
                                <div className='col-3'>
                                    <label htmlFor="clientDropdown">Client Name</label>
                                    <select id="clientDropdown" name="customerName" value={selectedClient} className='form-control' onChange={handleClientChange}>
                                        <option value="">--Select Client--</option>
                                        {clients.map((client, index) => (
                                            <option key={index} value={client}>{client}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className='col-3'>
                                    <label for="" class="form-label">Purchage Id</label>
                                    <select value={selectedPurchaseid} className='form-control' name="purchage_Id" onChange={handleUserChange}>
                                        <option value="">Select Purchage Id</option>
                                        {users.map(data => (
                                            <option key={data.purchage_Id} value={data.purchage_Id}>{data.purchage_Id}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <hr/>
                            <div className='row'>
                                <div className='col-3'>
                                    <label for="" class="form-label">Shipping Mark</label>
                                    <input type="text" readonly="true" name="shipping_mark" className='form-control' onChange={handleChange} value={shippingmark} />
                                </div>
                                <div className='col-3'>
                                    <label for="" class="form-label">Product Name</label>
                                    <input type="text" readonly="true" name="productName" className='form-control' onChange={handleChange} value={productName} />
                                </div>
                                <div className='col-2'>
                                    <label for="" class="form-label">Packing</label>
                                    <input type="text" readonly="true" name="packing" className='form-control' onChange={handleChange} value={packing} />
                                </div>
                                <div className='col-2'>
                                    <label for="" class="form-label">Weight</label>
                                    <input type="text" readonly="true" name="totalWeight" className='form-control' onChange={(e) => setBagWeight(Number(e.target.value))} value={bagWeight} />
                                </div>
                                <div className='col-2'>
                                    <label for="" class="form-label">Current Stock</label>
                                    <input type="text" readOnly="true" name="setTotalStock" className='form-control' onChange={handleChange} value={totalStock}/>
                                </div>                                 
                            </div>
                            <div className='row'>     
                                <div className='col-2'>
                                    <label for="" class="form-label">Sales Quantity</label>
                                    <input type="text" name="quantity" className='form-control' onChange={(e) => setSalesQuantity(Number(e.target.value))} value={salesQuantity} />
                                </div>       
                                <div className='col-2'>
                                    <label for="" class="form-label">Sales Shortage</label>
                                    <input type="text" name="shortage" className='form-control' onChange={(e) => setShortage(Number(e.target.value))} value={shortage} />
                                </div>
                                <div className='col-2'>
                                    <label for="" class="form-label">Total Weight</label>
                                    <input type="text" readonly="true" name="totalWeight" className='form-control' onChange={(e) => setSaleTotalWeight(Number(e.target.value))} value={saleTotalWeight} />
                                </div>
                                <div className='col-2'>
                                    <label for="" class="form-label">Price/Maan</label>
                                    <input type="text" name="price" className='form-control' onChange={(e) => setDataMaan(Number(e.target.value))} value={dataMaan} />
                                </div>
                                <div className='col-2'>
                                    <label for="" class="form-label">Sales Price</label>
                                    <input type="text" name="salesPrice" className='form-control' onChange={(e) => setSalesPrice(Number(e.target.value))} value={salesPrice} />
                                </div>
                                <div className='col-2'>
                                    <label for="" class="form-label">Total Price</label>
                                    <input type="text" readonly="true" name="saleTotalPrice" className='form-control' onChange={(e) => setSaleTotalPrice(Number(e.target.value))} value={saleTotalPrice} />
                                </div>                                
                            </div>
                            <div className='row'>
                                <div className='col-3'>
                                    <label for="" class="form-label">Due Date</label>
                                    <DatePicker selected={selectedDate} onChange={handleDateChange} className='form-control' dateFormat="yyyy-MMM-dd" />
                                </div>
                            </div>

                        </div>

                        <div className="row">
                            <div className='col-6 mt-5'>
                                <div className="d-grid gap-3">
                                    <input type="submit" onClick={printDocument} name="submit" value="Save New Sale" className="btn btn-primary btn-block" />                                    
                                </div>
                            </div>
                        </div>

                    </form>

                </div>

            </div>

        </div>
    )
}

export default NewSale;